import {stringifyId} from '../../../../../../../types'
import type {BuildTypeId, ProjectId} from '../../../../../../../types'
import {base_uri} from '../../../../../../../types/BS_types'
import {objectKeys} from '../../../../../../../utils/object'
import {limitOptionCaptions} from '../../CleanupForm/Sections/LimitsSection'
import type {Rule} from '../../Rules.types'

export const getWhatToSaveString = (rule: Rule): string => {
  const limits = rule.limit
  let value
  let caption = 'All'
  objectKeys(limits).forEach(key => {
    if (limits[key] != null) {
      caption = limitOptionCaptions[key]
      value = rule.limit[key]?.daysCount || rule.limit[key]?.buildsCount
    }
  })

  return value ? `${value} ${caption}` : caption
}
export const getHolderProjectLink = (id: (BuildTypeId | ProjectId) | null | undefined): string =>
  id != null ? `${base_uri}/admin/editProject.html?projectId=${stringifyId(id)}&tab=cleanup` : ''
export const getHolderTemplateLink = (id: (BuildTypeId | ProjectId) | null | undefined): string =>
  id != null ? `${base_uri}/admin/cleanupSettings.html?id=template:${stringifyId(id)}` : ''
export const getIfRuleKeepsEverything = (rule: Rule): boolean =>
  rule.keepBuildParts.everything != null &&
  rule.preserveArtifacts === true &&
  Object.values(rule.filters).every(value => value == null) &&
  Object.values(rule.partitions).every(value => value == null) &&
  rule.limit.all != null
export const getRemoveActionDescription = (isReset = false): string =>
  isReset
    ? `You are about to\u00a0reset the\u00a0current rule\u00a0definition and use the\u00a0rule inherited from\u00a0the\u00a0parent\u00a0project instead.`
    : `Are you sure you want to\u00a0delete this\u00a0rule?`
